import { useMemo, useState } from "react";
import { getReportCellSortValue } from "@/pages/reports/reportTableHelper";

/**
 * Client-side search + sort before pagination.
 */
export const useReportGridPipeline = (data = [], columns = []) => {
    const [searchText, setSearchText] = useState("");
    const [sortKey, setSortKey] = useState(null);
    const [sortDir, setSortDir] = useState("asc");

    const toggleSort = (key) => {
        if (sortKey === key) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDir("asc");
        }
    };

    const processedData = useMemo(() => {
        let rows = [...(data || [])];
        const q = searchText.trim().toLowerCase();

        if (q) {
            rows = rows.filter((row) =>
                columns.some((col) => {
                    const raw = getReportCellSortValue(row, col);
                    return String(raw ?? "").toLowerCase().includes(q);
                })
            );
        }

        if (sortKey) {
            const col = columns.find((c) => c.key === sortKey);
            rows.sort((a, b) => {
                const av = getReportCellSortValue(a, col);
                const bv = getReportCellSortValue(b, col);
                if (av == null && bv == null) return 0;
                if (av == null) return 1;
                if (bv == null) return -1;
                if (typeof av === "number" && typeof bv === "number") {
                    return sortDir === "asc" ? av - bv : bv - av;
                }
                const cmp = String(av).localeCompare(String(bv), undefined, { numeric: true });
                return sortDir === "asc" ? cmp : -cmp;
            });
        }

        return rows;
    }, [data, columns, searchText, sortKey, sortDir]);

    const clearSearch = () => setSearchText("");

    return {
        searchText,
        setSearchText,
        clearSearch,
        sortKey,
        sortDir,
        toggleSort,
        processedData,
    };
};
